import React, { useState } from "react";
import { Waypoint } from "react-waypoint";

function About() {
  const [animateleft, setAnimateLeft] = useState("");
  const [animateUp, setAnimateUp] = useState("");
  const [animateRight, setAnimateRight] = useState("");

  const handleWaypointEnterLeft = () => {
    setAnimateLeft("visible animate__animated animate__fadeInLeft");
  };
  const handleWaypointEnterUp = () => {
    setAnimateUp("visible animate__animated animate__backInUp");
  };
  const handleWaypointEnterRight = () => {
    setAnimateRight("visible animate__animated animate__fadeInRight");
  };

  return (
    <section className="about-me" id="about">
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <Waypoint onEnter={handleWaypointEnterLeft}>
              <div className={`section-title hide ${animateleft}`}>
                <h1 className="title">About</h1>
                <h1 className="title title-fill">Me</h1>
              </div>
            </Waypoint>
            <Waypoint onEnter={handleWaypointEnterUp}>
              <p className={`hide ${animateUp}`}>
                As a front-end developer, I bring my expertise in responsive
                design and UI/UX design to the table to craft beautiful,
                user-friendly websites. My proficiency in React, JavaScript,
                HTML5, and CSS3 allows me to create dynamic and interactive
                interfaces, ensuring that the websites I build perform optimally
                on all devices. Additionally, I am well-versed in web analytics
                and SEO, ensuring that the sites I develop are not only
                aesthetically pleasing but also effectively reach and engage the
                target audience. I am passionate about my work and continuously
                strive to deliver high-quality, innovative solutions that exceed
                my clients' expectations.
              </p>
            </Waypoint>
          </div>
          <div className="col-lg-6 rightside-img">
            <Waypoint onEnter={handleWaypointEnterRight}>
              <img
                className={`img-fluid hide ${animateRight}`}
                src={require("../images/10168.jpg")}
                alt=""
              />
            </Waypoint>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
